import React from "react";
import PropTypes from "prop-types";
import { Crumbs } from "../../BreadCrumbs";
import { toUIDate } from "../../../components/Utils";

function SearchResultItem({ className, data, labelMap, searchedText }) {
  if (!data) return null;

  return (
    <div className={`search-result-item ${className}`}>
      <a
        className="pad-big w3-hover-light-grey w3-block"
        href={`${data.pathname}?q=${searchedText}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <h2 className="no-margin">{data.pageTitle}</h2>
        <div className="clearfix">
          <Crumbs
            className="w3-large"
            pathname={data.pathname}
            labelMap={labelMap}
          />
          <div className="overlay" />
        </div>
        <div className="w3-text-grey pad-sm-top">
          <span className="bold">{"Letze Änderung: "}</span>
          {toUIDate(data.created_date)}
        </div>
      </a>
    </div>
  );
}

SearchResultItem.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object,
  labelMap: PropTypes.shape({}).isRequired,
  searchedText: PropTypes.string,
};

export default SearchResultItem;
